<template>
  <div :class="{ 'base-layout': needFooter, layout: !needFooter, 'has-header': needHeader || !!customHeader }">
    <Header v-if="needHeader && !customHeader" />
    <custom-header-bar v-bind="customHeader" v-if="!!customHeader" />
    <van-pull-refresh
      v-model="isPullRefresh"
      :head-height="headerHeight"
      :disabled="!isPageRefresh"
      @refresh="onRefresh"
    >
      <main class="page" :class="{ loading: isPageLoading }">
        <router-view v-slot="{ Component, route }">
          <template v-if="needAnimation">
            <Transition :name="transitionName">
              <keep-alive v-if="route.meta?.needCache">
                <component :is="Component" :key="route.name" />
              </keep-alive>
              <component :is="Component" :key="route.name" v-else />
            </Transition>
          </template>
          <template v-else>
            <keep-alive>
              <component v-if="route.meta?.needCache" :is="Component" :key="route.name + custId" />
            </keep-alive>
            <component v-if="!route.meta?.needCache" :is="Component" :key="route.name + custId" />
          </template>
        </router-view>
      </main>
    </van-pull-refresh>
    <GNotice type="newVersion" />
    <PageLoading :class="{ 'has-header': needHeader || !!customHeader, 'has-footer': needFooter }" />
    <Footer v-if="needFooter" />
  </div>

  <!--客服-->
  <!--<van-floating-bubble
    class="services-btn"
    axis="lock"
    @click="goServices"
    v-if="showServices && isServices"
    :style="{ bottom: needFooter ? 'calc(var(--footer-height) + 100px)' : '100px' }"
  >
    <img class="icon" src="@/assets/img/home/services.png" alt="客服" />
    <span class="text">客服</span>
  </van-floating-bubble>-->

  <!--返回顶部-->
  <van-back-top
    class="back-top-btn"
    teleport="#app"
    :bottom="needFooter ? 'calc(var(--footer-height) + 5px)' : '20px'"
    @click="backTopHandle"
  >
    <img class="icon" src="@/assets/img/home/go_top.png" alt="返回顶部" />
    <span class="text">TOP</span>
  </van-back-top>

  <!--活动弹窗-->
  <ActivityPopup />

  <!--浮动活动轮播-->
  <HomeActivityEntry v-if="isHome" />

  <!--登录注册-->
  <LoginRegister />

  <!--下载引导-->
  <footer-download v-if="isHome" />
</template>

<script setup lang="ts">
import { computed, onBeforeMount, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { emitter, EventEnum } from '@star/utils';
import {
  storeToRefs,
  useAppStore,
  useGameStore,
  useHot,
  useModalStore,
  useTenantStore,
  useUserStore,
} from '@star/stores';
import GNotice from '../components/gNotice/index.vue';
import Header from './header/index.vue';
import Footer from './footer/index.vue';
import PageLoading from '@/components/pageLoading/index.vue';
import CustomHeaderBar from '@/components/CustomHeaderBar/index.vue';
import LoginRegister from './header/components/loginRegister/index.vue';
import { useWindowScroll, useWindowSize } from '@vueuse/core';
import { includes, startsWith } from 'lodash-es';
import { GameMainTypesEnum, ModalTypeEnum, ThemeEnum } from '@star/constants';
import FooterDownload from './footer/components/FooterDownload.vue';
import { G_goLogin, G_goRegister } from '@/plugins/public_utils';
import HomeActivityEntry from '@/pages/activity/HomeActivityEntry/index.vue';
import ActivityPopup from './ActivityPopup/index.vue';

const router = useRouter();
const uRoute = useRoute();
const userStore = useUserStore();
const appStore = useAppStore();
const modalStore = useModalStore();
const tenantState = useTenantStore();
const { isPullRefresh, isPageLoading, headerHeight, formRoute, theme } = storeToRefs(appStore);
const { activeHomeMainMenuTab } = storeToRefs(useGameStore());
const { isRepairing } = storeToRefs(tenantState);
const { isLogin, userInfo } = storeToRefs(userStore);
const transitionName = ref('page-fadeInLeft');
const preRoutes = ref<string[]>([]);
// const excludeRouters = ref<string[]>([]);
const showServices = ref<boolean>(false);

const homePageTopHeight = ref<number>(0);
const { activeConfiguration } = useHot();

const { y } = useWindowScroll();
const { width, height } = useWindowSize();
const offset = ref({ x: width.value - 61, y: height.value - 250 });

const custId = computed(() => {
  console.log(userInfo.value?.cust_id, 'custId');
  return userInfo.value?.cust_id || 0;
});

const isServices = computed(() => {
  // console.log(!startsWith(uRoute.name as string, 'game-'), uRoute.name, '8888888888');
  return (
    activeConfiguration.value?.['68'] &&
    !startsWith(uRoute.name as string, 'game-') &&
    !includes(['services', 'findBalance'], uRoute.name) &&
    !isRepairing.value
  );
});

const isHome = computed(() => {
  return uRoute.name === 'home';
});

const needAnimation = computed(() => {
  return uRoute.meta?.animation;
});

const needHeader = computed(() => {
  return uRoute.meta?.header || includes([ThemeEnum.DARK], theme.value);
});

const needFooter = computed(() => {
  return uRoute.meta?.footer;
});

// 自定义头部
const customHeader = computed(() => {
  return uRoute.meta?.customHeader as Record<string, any>;
});

// 页面是否启用下拉刷新
const isPageRefresh = computed(() => {
  return !!uRoute.meta?.refresh && y.value < headerHeight.value;
});

const onRefresh = () => {
  if (isPageRefresh.value) {
    emitter.emit(EventEnum.REFRESH_PAGE);
  } else {
    appStore.setPullRefresh(!1);
  }
};

const goServices = () => {
  router.push('/services');
};

const backTopHandle = () => {
  console.log('backTopHandle', homePageTopHeight.value);
  if (+activeHomeMainMenuTab.value !== GameMainTypesEnum.RECOMMEND) {
    setTimeout(() => {
      window.scrollTo({ top: homePageTopHeight.value, behavior: 'smooth' });
    }, 50);
  }
};

watch(
  () => isRepairing.value,
  value => {
    console.log(isRepairing.value, 'isRepairing.value +++++');
    if (value) {
      setTimeout(() => {
        router.push('/maintenance');
      }, 0);
    }
  },
  {
    immediate: true,
  }
);

router.beforeEach((to, from, next) => {
  // console.log(from, 'beforeEach from 9999999999999999999999999999999999');
  // console.log(to, 'beforeEach to 9999999999999999999999999999999999');
  // console.log(formRoute.value.name, 'beforeEach formRoute.value.name 9999999999999999999999999999999999');
  // const name = to.name as string;
  // if (to.meta?.needCache && name && !excludeRouters.value.includes(name)) {
  //   excludeRouters.value.push(name);
  // }
  if (preRoutes.value.includes(to.path)) {
    transitionName.value = 'page-fadeInRight';
    preRoutes.value = preRoutes.value.filter(x => x !== to.path);
  } else {
    transitionName.value = 'page-fadeInLeft';
    preRoutes.value.push(from.path);
  }

  if (isPullRefresh.value) {
    appStore.setPullRefresh(false);
  }

  if (formRoute.value.name !== from.name) {
    formRoute.value.name = from.name;
    formRoute.value.fullPath = from.fullPath;
  }

  if (to.name === 'services' && from.name) {
    // 记录进入客服页面时的来源路径
    sessionStorage.setItem(
      'services-page-from',
      JSON.stringify({
        path: from.path,
        name: from.name,
        params: from.params,
        query: from.query,
      })
    );
  }

  // 登录后访问
  if (to.meta?.login && !isLogin.value) {
    modalStore.addPopupModal(ModalTypeEnum.LOGIN_REGISTER_MODAL, { type: 1 });
    next('/home');
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  // console.log(to, 'initModal afterEach to');
  if (!includes(['home'], to.name)) {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  }
  if (to.name === 'home' && to.name !== from.name) {
    modalStore.setHighFrequencyModalStatus();
    setTimeout(() => {
      modalStore.initModal();
    }, 300);
  }
});

emitter.on(EventEnum.HOME_PAGE_TOP_HEIGHT, (val: number) => {
  homePageTopHeight.value = val;
});

onBeforeMount(() => {
  if (uRoute.query.code && !isLogin.value) {
    //邀请链接跳转过来显示注册弹窗
    G_goRegister(uRoute.query);
  }
  if (uRoute.meta?.login && !isLogin.value) {
    G_goLogin();
  }
});

onMounted(() => {
  // setTimeout(() => {
  //   showServices.value = true;
  // }, 1000);
});
</script>

<style lang="less">
.back-top-btn {
  width: 146px !important;
  height: 184px !important;
  border-radius: 146px;
  box-shadow: 0 2px 27px 0 rgb(203 203 203 / 59%);
  background: #fff !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #838383 !important;
  font-size: 33px;
  right: 36px !important;

  .icon {
    width: 54px;
    margin-top: 6px;
    margin-bottom: 12px;
  }
}

div.back-top-btn {
  position: fixed;
  right: 36px !important;
  z-index: 1000;
  left: auto !important;
}

.services-btn {
  width: 146px !important;
  height: 184px !important;
  border-radius: 146px;
  box-shadow: 0 2px 27px 0 rgb(203 203 203 / 59%);
  background: #fff !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--theme-primary-color) !important;
  font-size: 33px;
  position: fixed;
  right: 36px !important;
  //bottom: 500px !important;
  z-index: 1000;
  top: auto !important;
  left: auto !important;
  transform: none !important;

  .icon {
    width: 102px;
    margin-top: 6px;
    margin-bottom: 12px;
  }
}
</style>

<style scoped lang="less">
.base-layout {
  width: 100%;
  min-height: min(100vh, var(--view-height));
  margin-top: 0;
  background-color: var(--theme-app-backgroud-color);

  :deep(.page) {
    min-height: min(100vh, var(--view-height));
    padding-bottom: calc(var(--footer-height) + 36px);
  }

  &.has-header {
    :deep(.page) {
      min-height: calc(min(100vh, var(--view-height)) - var(--header-height));
    }
  }
}

.layout {
  width: 100%;
  padding: 0;
  min-height: min(100vh, var(--view-height));
  background-color: var(--theme-app-backgroud-color);

  :deep(.page) {
    min-height: min(100vh, var(--view-height));
  }

  &.has-header {
    :deep(.page) {
      min-height: calc(min(100vh, var(--view-height)) - var(--header-height));
    }
  }
}

main.loading {
  display: none;
  overflow: hidden;
}
</style>
